/* GetGames — JavaScript del tema.

   Deliberadamente minimo. Todo lo importante funciona SIN JavaScript:

   - La ficha agrega al carrito: el selector de modalidad son radios con
     name="id" dentro del form que hace POST a /cart/add.
   - Sin JS, todos los bloques de "Que recibes exactamente" quedan visibles.
     Ese es el fallback correcto a proposito: de mas informacion, nunca de
     menos.
   - El hero y los carruseles son scroll nativo con scroll-snap.
   - Los filtros de coleccion son un <form> GET con boton de envio.

   Este archivo solo agrega mejoras progresivas. */
(function () {
  'use strict';

  var forEach = function (list, fn) {
    Array.prototype.forEach.call(list, fn);
  };

  /* --- Ficha de producto ------------------------------------------------ */

  function initProduct(root) {
    /* Galeria: las miniaturas cambian la imagen grande. Va antes del
       chequeo del formulario porque tambien aplica a productos de una
       sola modalidad. */
    var mainWrap = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (mainWrap && thumbs.length) {
      var mainImg = mainWrap.querySelector('img');
      forEach(thumbs, function (btn) {
        btn.addEventListener('click', function () {
          if (!mainImg) return;
          var full = btn.getAttribute('data-full');
          var srcset = btn.getAttribute('data-srcset');
          var alt = btn.getAttribute('data-alt');
          if (full) mainImg.src = full;
          if (srcset) mainImg.srcset = srcset;
          if (alt !== null) mainImg.alt = alt;
          forEach(thumbs, function (other) {
            other.classList.toggle('is-active', other === btn);
            /* aria-current acompana a la clase: el estado activo tiene
               que existir tambien para el lector de pantalla. */
            if (other === btn) {
              other.setAttribute('aria-current', 'true');
            } else {
              other.removeAttribute('aria-current');
            }
          });
        });
      });
    }

    var form = root.querySelector('[data-product-form]');
    if (!form) return;

    var radios = root.querySelectorAll('[data-modality-input]');
    if (!radios.length) return; /* producto de una sola modalidad */

    var submit = form.querySelector('[data-add-to-cart]');
    var priceTarget = root.querySelector('[data-price-target]');
    var blocks = root.querySelectorAll('[data-whatyouget-for]');
    var facts = root.querySelectorAll('[data-facts-for]');
    var live = form.querySelector('[data-variant-live]');

    function toggle(nodes, attr, id) {
      forEach(nodes, function (node) {
        node.hidden = node.getAttribute(attr) !== id;
      });
    }

    function select(radio, pushUrl) {
      var id = radio.value;

      if (priceTarget) {
        var markup = radio.getAttribute('data-price-html');
        if (markup) {
          priceTarget.innerHTML = markup;
          /* El HTML nuevo llega en dolares desde Liquid. Si el cliente esta
             viendo otra moneda, este aviso hace que se vuelva a convertir;
             sin el, cambiar de modalidad devolvia el precio a dolares y
             solo ese, con el resto de la pagina convertido. */
          document.dispatchEvent(new CustomEvent('gg:precios-actualizados'));
        }
      }

      toggle(blocks, 'data-whatyouget-for', id);
      toggle(facts, 'data-facts-for', id);

      if (submit) {
        var available = radio.getAttribute('data-available') === 'true';
        submit.disabled = !available;
        var label = submit.getAttribute(
          available ? 'data-label-available' : 'data-label-soldout'
        );
        if (label) submit.textContent = label;
      }

      /* Anuncia el cambio al lector de pantalla (solo en cambios del
         usuario, no en la carga inicial). Patron clear-then-set para que
         repetir la misma modalidad tambien se anuncie. */
      if (pushUrl && live) {
        var liveText = radio.getAttribute('data-live-text');
        if (liveText) {
          live.textContent = '';
          window.requestAnimationFrame(function () {
            live.textContent = liveText;
          });
        }
      }

      if (pushUrl && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          /* URL no soportada: no es critico */
        }
      }
    }

    forEach(radios, function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) select(radio, true);
      });
    });

    var checked = form.querySelector('[data-modality-input]:checked');
    if (checked) select(checked, false);
  }

  forEach(document.querySelectorAll('[data-product-root]'), initProduct);

  /* --- Cantidad con botones - / + -------------------------------------
     Los botones llegan ocultos desde Liquid: sin JavaScript el input
     numerico sigue funcionando solo. */

  forEach(document.querySelectorAll('[data-quantity]'), function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input || !minus || !plus) return;

    function bump(delta) {
      var value = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      input.value = Math.max(min, value + delta);
    }

    minus.hidden = false;
    plus.hidden = false;
    minus.addEventListener('click', function () { bump(-1); });
    plus.addEventListener('click', function () { bump(1); });
  });

  /* --- Carruseles de producto ------------------------------------------
     Las flechas llegan ocultas desde Liquid y solo se muestran si de verdad
     hay algo que desplazar. Un control que no hace nada es peor que no
     tener control. */

  forEach(document.querySelectorAll('.carousel-wrap'), function (wrap) {
    var track = wrap.querySelector('[data-carousel]');
    var prev = wrap.querySelector('[data-carousel-prev]');
    var next = wrap.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    function step() {
      var first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }

    function sync() {
      var scrollable = track.scrollWidth - track.clientWidth > 4;
      prev.hidden = !scrollable || track.scrollLeft <= 2;
      next.hidden = !scrollable || track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* --- Puntos del hero -------------------------------------------------
     Los puntos son enlaces ancla, asi que navegan sin JS. Esto solo marca
     cual esta activo mientras se desliza. */

  forEach(document.querySelectorAll('[data-hero]'), function (hero) {
    var dots = hero.parentNode.querySelector('[data-hero-dots]');
    if (!dots) return;
    var links = dots.querySelectorAll('a');
    if (!links.length) return;

    function paint() {
      var index = Math.round(hero.scrollLeft / Math.max(hero.clientWidth, 1));
      forEach(links, function (link, i) {
        link.style.background = i === index ? 'var(--gg-green-fill)' : '';
        if (i === index) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    hero.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });

  /* --- Carrusel de banners --------------------------------------------
     Avanza de una imagen a la vez. Se detiene al pasar el raton o al
     enfocar con teclado, para que no se mueva mientras alguien la mira, y
     no arranca si el visitante pidio movimiento reducido en su sistema. */

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  forEach(document.querySelectorAll('[data-banner-carousel]'), function (track) {
    var slides = track.children;
    if (slides.length < 2) return;

    var wrap = track.parentNode;
    var dots = wrap.querySelector('[data-banner-dots]');
    var links = dots ? dots.querySelectorAll('a') : [];
    /* Piso de 5s (WCAG): tiendas configuradas antes del cambio de schema
       pueden traer 3-4s guardados. */
    var interval = Math.max(parseInt(track.getAttribute('data-interval'), 10) || 5000, 5000);
    var timer = null;
    var userPaused = false;

    function index() {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }

    function paint() {
      var i = index();
      forEach(links, function (link, n) {
        if (n === i) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function advance() {
      var next = index() + 1;
      if (next >= slides.length) next = 0;
      track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
    }

    function start() {
      if (timer || userPaused || (reduceMotion && reduceMotion.matches)) return;
      timer = window.setInterval(advance, interval);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    track.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);

    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);
    wrap.addEventListener('focusin', stop);
    wrap.addEventListener('focusout', start);

    /* Detiene el avance mientras la pestana no esta visible: si no, al
       volver hay una rafaga de saltos acumulados. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    if (reduceMotion && reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function () {
        if (reduceMotion.matches) { stop(); } else { start(); }
      });
    }

    /* Boton de pausa: llega oculto desde Liquid y solo aparece si hay JS
       que lo haga funcionar. Pausar con el es una decision del usuario:
       gana a hover/focus/visibilidad hasta que el mismo reanude. */
    var pauseBtn = wrap.querySelector('[data-banner-pause]');
    if (pauseBtn) {
      pauseBtn.hidden = false;
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute(
          userPaused ? 'data-label-play' : 'data-label-pause'
        ));
        if (userPaused) { stop(); } else { start(); }
      });
    }

    paint();
    start();
  });

  /* --- Pausa del marquee de anuncios -----------------------------------
     La animacion es CSS; el boton solo alterna una clase. Llega oculto
     desde Liquid: sin JavaScript no podria pausar nada. */

  forEach(document.querySelectorAll('[data-marquee]'), function (marquee) {
    var btn = marquee.querySelector('[data-marquee-pause]');
    if (!btn) return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var paused = marquee.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(
        paused ? 'data-label-play' : 'data-label-pause'
      ));
    });
  });

  /* --- Ventana de bienvenida ------------------------------------------

     Aparece una sola vez por visitante y solo tras el retraso configurado.
     Lo que ya vio o ya cerro vive en localStorage suyo, no en el servidor.
     Si el navegador bloquea el almacenamiento (modo privado en iOS lo
     hace), la ventana simplemente se muestra: es preferible eso a
     reventar el script entero. */

  forEach(document.querySelectorAll('[data-promo-popup]'), function (popup) {
    var key = popup.getAttribute('data-storage-key') || 'gg-promo';
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 8000;
    var opener = null;

    function remember() {
      try { window.localStorage.setItem(key, '1'); } catch (e) {}
    }

    function seen() {
      try { return window.localStorage.getItem(key) === '1'; } catch (e) { return false; }
    }

    function close() {
      popup.hidden = true;
      document.body.style.removeProperty('overflow');
      remember();
      if (opener && opener.focus) opener.focus();
    }

    function open() {
      opener = document.activeElement;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      /* Tras suscribirse ya no hay casilla: el foco va al boton de
         cerrar, para que la ventana no se abra con el foco en la nada. */
      var target =
        popup.querySelector('input[type="email"]') ||
        popup.querySelector('.promo-popup__decline');
      if (target) target.focus({ preventScroll: true });
    }

    forEach(popup.querySelectorAll('[data-promo-close]'), function (btn) {
      btn.addEventListener('click', close);
    });

    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;

      /* El foco no puede escaparse a la pagina de detras mientras la
         ventana esta abierta. */
      var focusables = popup.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    /* Al volver del envio, Shopify recarga con ?customer_posted=true: ahi
       se abre de inmediato para que el visitante lea la confirmacion.

       Y antes de abrirla, se deshace el salto al pie. Shopify manda
       CUALQUIER `{% form 'customer' %}` a `/contact#contact_form`, con
       ese id fijo: en esta tienda hay dos —el boletin del pie y esta
       ventana— asi que el ancla sobrevive al redirect y el navegador
       aterriza en el primero que encuentra, que es el del pie. La
       ventana es `fixed` y lo tapa, pero al cerrarla el visitante
       aparece en el pie sin haber bajado nunca.

       Se vuelve arriba y se borra el ancla de la barra de direcciones,
       para que una recarga no repita el salto. Si el navegador no deja
       reescribir la URL, el scroll ya esta hecho igual. */
    if (popup.querySelector('.promo-popup__ok')) {
      window.scrollTo(0, 0);
      if (window.history && window.history.replaceState) {
        try {
          window.history.replaceState(
            null,
            '',
            window.location.pathname + window.location.search
          );
        } catch (e) {}
      }
      open();
      remember();
      return;
    }

    if (seen()) return;
    window.setTimeout(open, delay);
  });

  /* --- Buscador predictivo ---------------------------------------------
     Mejora progresiva pura. Sin este archivo el panel sigue abriendo (es un
     <details>) y el formulario sigue enviando a /search: lo unico que se
     pierde son los resultados mientras se escribe.

     Los resultados los renderiza Shopify, no este archivo: se pide la
     seccion predictive-search y se inyecta el HTML ya hecho. Asi la tarjeta
     del resultado vive en Liquid, con los tokens de marca, en vez de
     armarse pegando strings aqui. */

  forEach(document.querySelectorAll('[data-search]'), function (root) {
    var input = root.querySelector('[data-search-input]');
    var results = root.querySelector('[data-search-results]');
    if (!input || !results) return;

    var timer = null;
    var controller = null;
    var ultimo = '';

    function limpiar() {
      results.innerHTML = '';
      ultimo = '';
    }

    function pedir(termino) {
      /* Una peticion en vuelo a la vez: al teclear rapido las respuestas
         pueden llegar desordenadas y pintar resultados viejos encima de
         los nuevos. */
      if (controller) controller.abort();
      controller = new AbortController();

      var url = '/search/suggest' +
        '?q=' + encodeURIComponent(termino) +
        '&resources[type]=product' +
        '&resources[limit]=8' +
        '&section_id=predictive-search';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          /* Shopify devuelve la seccion envuelta; nos quedamos con su
             contenido para no anidar divs de mas. */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var seccion = doc.querySelector('.shopify-section') || doc.body;
          results.innerHTML = seccion.innerHTML;
          /* Los resultados llegan de Shopify en dolares, igual que el
             precio de la ficha al cambiar de modalidad. */
          document.dispatchEvent(new CustomEvent('gg:precios-actualizados'));
        })
        .catch(function (err) {
          /* Abortar es lo normal aqui, no un fallo que reportar. */
          if (err && err.name === 'AbortError') return;
          limpiar();
        });
    }

    input.addEventListener('input', function () {
      var termino = input.value.trim();
      window.clearTimeout(timer);

      if (termino.length < 2) { limpiar(); return; }
      if (termino === ultimo) return;
      ultimo = termino;

      /* Se espera a que deje de teclear: una peticion por letra satura y
         hace parpadear la lista. */
      timer = window.setTimeout(function () { pedir(termino); }, 200);
    });

    /* Al abrir el panel, el foco va al campo: si hay que hacer clic dentro
       para escribir, la mitad de la gente no lo hace. */
    root.addEventListener('toggle', function () {
      if (root.open) input.focus();
      else limpiar();
    });
  });

  /* --- Moneda de visualizacion ------------------------------------------
     La tienda cobra en USD y esto no lo cambia: reescribe lo que se LEE,
     para que alguien en Bogota o en Ciudad de Mexico sepa cuanto le cuesta
     sin salir a buscar la tasa. El aviso de "se cobra en USD" aparece con
     la conversion y desaparece al volver a dolares.

     Las tasas salen de los ajustes del tema, no de una API: un precio que
     depende de que un tercero responda es un precio que algun dia no
     aparece. Ver snippets/currency-switcher.liquid. */

  var MONEDA_KEY = 'gg-moneda';

  function leerTasas() {
    var el = document.querySelector('[data-currency-rates]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Cada moneda se escribe con la puntuacion de su pais, no con la de
     Panama: un colombiano lee 45.920, no 45,920, y ver su propia moneda
     con separadores ajenos es justo lo que hace dudar de la cifra. */
  var LOCALES = { COP: 'es-CO', MXN: 'es-MX', EUR: 'es-ES', USD: 'es-PA' };

  function formatear(centavos, moneda, tasa) {
    var valor = (centavos / 100) * tasa;
    /* El peso colombiano no se maneja con centavos en la calle: mostrarlos
       da una precision que la tasa no tiene. */
    var decimales = moneda === 'COP' ? 0 : 2;
    try {
      return new Intl.NumberFormat(LOCALES[moneda] || 'es-PA', {
        style: 'currency', currency: moneda, currencyDisplay: 'code',
        minimumFractionDigits: decimales, maximumFractionDigits: decimales,
      }).format(valor);
    } catch (e) {
      return moneda + ' ' + valor.toFixed(decimales);
    }
  }

  function pintarMoneda(moneda, tasas) {
    var convertir = moneda !== 'USD' && tasas && tasas[moneda];

    forEach(document.querySelectorAll('[data-gg-money]'), function (el) {
      var centavos = parseInt(el.getAttribute('data-gg-money'), 10);
      if (isNaN(centavos)) return;
      /* El texto original en dolares se guarda la primera vez: volver a
         USD tiene que devolver el formato exacto de la tienda, no uno que
         reconstruya el JS y se parezca. */
      if (!el.hasAttribute('data-gg-money-usd')) {
        el.setAttribute('data-gg-money-usd', el.textContent.trim());
      }
      el.textContent = convertir
        ? formatear(centavos, moneda, tasas[moneda])
        : el.getAttribute('data-gg-money-usd');
    });

    /* El ahorro vive dentro de una frase: se cambia solo su importe. */
    forEach(document.querySelectorAll('[data-gg-money-swap]'), function (el) {
      var centavos = parseInt(el.getAttribute('data-gg-money-swap'), 10);
      var usd = el.getAttribute('data-gg-money-usd');
      if (isNaN(centavos) || !usd) return;
      if (!el.hasAttribute('data-gg-frase')) {
        el.setAttribute('data-gg-frase', el.textContent.trim());
      }
      var frase = el.getAttribute('data-gg-frase');
      el.textContent = convertir
        ? frase.replace(usd, formatear(centavos, moneda, tasas[moneda]))
        : frase;
    });

    forEach(document.querySelectorAll('[data-currency-note]'), function (el) {
      el.hidden = !convertir;
    });

    forEach(document.querySelectorAll('[data-currency-select]'), function (el) {
      if (el.value !== moneda) el.value = moneda;
    });
  }

  (function moneda() {
    var tasas = leerTasas();
    var selects = document.querySelectorAll('[data-currency-select]');
    if (!tasas || !selects.length) return;

    var guardada = 'USD';
    try { guardada = localStorage.getItem(MONEDA_KEY) || 'USD'; } catch (e) { /* modo privado */ }
    /* Una moneda guardada cuya tasa ya no existe vuelve a dolares sola. */
    if (guardada !== 'USD' && !tasas[guardada]) guardada = 'USD';

    forEach(document.querySelectorAll('[data-currency]'), function (el) { el.hidden = false; });

    forEach(selects, function (el) {
      el.addEventListener('change', function () {
        var elegida = el.value;
        try { localStorage.setItem(MONEDA_KEY, elegida); } catch (e) { /* modo privado */ }
        pintarMoneda(elegida, tasas);
      });
    });

    pintarMoneda(guardada, tasas);
  })();

  /* Los precios de la ficha se repintan al cambiar de modalidad, asi que
     la conversion tiene que volver a aplicarse sobre el HTML nuevo. */
  document.addEventListener('gg:precios-actualizados', function () {
    var tasas = leerTasas();
    if (!tasas) return;
    var moneda = 'USD';
    try { moneda = localStorage.getItem(MONEDA_KEY) || 'USD'; } catch (e) { /* modo privado */ }
    if (moneda !== 'USD') pintarMoneda(moneda, tasas);
  });

  /* --- Paneles de la cabecera: cerrar ------------------------------------
     Los tres paneles (menu movil, buscador y desplegables del menu) son
     <details> y abren solos. Esto solo agrega lo que el navegador no da:
     cerrarlos con Escape o con un clic fuera. Sin JavaScript se cierran
     volviendo a pulsar su boton, que es como funciona un <details>. */

  var PANELES = 'details.mobile-nav[open], details.search[open], details.nav-drop[open]';

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    forEach(document.querySelectorAll(PANELES), function (el) {
      el.removeAttribute('open');
      /* El foco se queda dentro de un panel que ya no se ve: se devuelve
         al boton que lo abrio, que es donde el teclado espera estar. */
      if (el.contains(document.activeElement)) {
        var boton = el.querySelector('summary');
        if (boton) boton.focus();
      }
    });
  });

  document.addEventListener('click', function (event) {
    forEach(document.querySelectorAll('details.search[open], details.nav-drop[open]'), function (el) {
      if (!el.contains(event.target)) el.removeAttribute('open');
    });
  });

  /* --- Cuenta atras de la oferta -------------------------------------
     Sustituye los dias que pinta Liquid por el conteo vivo. Sin este
     bloque la ficha sigue diciendo la verdad, solo que redondeada a
     dias: ver snippets/offer-countdown.liquid.

     CUANDO LLEGA A CERO ESCONDE EL BLOQUE Y PARA EL INTERVALO. Un
     contador parado en 00h 00m 00s es peor que ninguno: anuncia que la
     oferta termino y deja el boton de comprar al lado, al precio viejo.
     Prefiere desaparecer.

     La fecha viene en `data-ends` con su desfase horario incluido, asi
     que Date.parse la interpreta igual en Panama que en Madrid. Si el
     atributo no se puede leer, no se toca nada y se queda lo de Liquid:
     el peor caso es una cifra mas gruesa, nunca una equivocada. */
  forEach(document.querySelectorAll('[data-countdown]'), function (el) {
    var fin = Date.parse(el.getAttribute('data-ends'));
    var salida = el.querySelector('[data-countdown-value]');
    if (isNaN(fin) || !salida) return;

    function dos(n) { return (n < 10 ? '0' : '') + n; }

    function pinta() {
      var queda = Math.floor((fin - Date.now()) / 1000);
      if (queda <= 0) {
        el.hidden = true;
        return true;
      }
      var d = Math.floor(queda / 86400);
      var h = Math.floor((queda % 86400) / 3600);
      var m = Math.floor((queda % 3600) / 60);
      var s = queda % 60;
      salida.textContent = (d > 0 ? d + 'd ' : '') + dos(h) + 'h ' + dos(m) + 'm ' + dos(s) + 's';
      return false;
    }

    if (pinta()) return;
    var tic = setInterval(function () {
      if (pinta()) clearInterval(tic);
    }, 1000);
  });
})();
